// Piezas compartidas por los pasos del asistente.
export const esHallazgo = (v) => v === 'alerta' || v === 'falla';

export const ETIQUETA_ESTADO = { aprobado: 'Aprobado', alerta: 'Alerta', falla: 'Falla' };

// Campo de texto grande: 16 px o más (iOS no hace zoom) y alto contraste.
export const CAMPO_TEXTO =
  'w-full rounded-xl border border-input bg-white p-3 text-base text-foreground ' +
  'placeholder:text-muted-foreground focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/25';

export const fotosTexto = (n) => (n === 1 ? '1 foto' : `${n} fotos`);
